<template>
  <v-dialog
    v-model.lazy="dialog"
    scrollable
    width="80%"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        :class="btnClass"
        color="primary"
        icon
        text
        small
        v-on="on"
      >
        <slot />
      </v-btn>
    </template>
    <v-card v-if="dialog">
      <v-card-title class="headline">
        Visualization builder
      </v-card-title>
      <v-divider />
      <v-card-text :style="{maxHeight:(height)+'px'}">
        <v-container fluid>
          <v-row>
            <v-col
              class="pa-3"
              cols="5"
              offset="1"
            >
              <div class="title mb-4">
                Configuration
              </div>
              <v-form
                ref="form"
                v-model.lazy="element_temp.valid"
                lazy-validation
              >
                <v-select
                  v-model.lazy="element_temp.type"
                  :items="items.types"
                  :rules="rules['type']"
                  label="Visualization type"
                  @change="handleTypeSelection"
                />
                <v-text-field
                  v-model.lazy="element_temp.label"
                  label="Visualization label"
                  :counter="50"
                  :rules="rules['label']"
                />
                <v-tabs
                  v-if="Object.keys(element_temp.options).length>0"
                  v-model.lazy="configTab"
                  class="mt-4"
                  left
                >
                  <v-tab
                    v-for="(t,name, index) in element_temp.options"
                    :key="index"
                  >
                    {{ name }}
                  </v-tab>
                  <v-tab-item
                    v-for="(t,name, t_index) in element_temp.options"
                    :key="t_index"
                    :transition="false"
                    :reverse-transition="false"
                    class="pt-5"
                  >
                    <template v-for="(p,p_name, p_index) in t">
                      <v-text-field
                        v-if="p.type==='String' || p.type=== 'Number'"
                        :key="p_index"
                        v-model.lazy="p.value"
                        :disabled="p.isDisabledBy ? t[p.isDisabledBy].value:false"
                        :min="p.min"
                        :max="(p.max =='rows' ? data.rows.length :p.max)"
                        :type="p.type.name"
                        :label="p_name"
                        :rules="VIZ_CONFIGS[element_temp.type][name][p_name].rules || []"
                        :counter="p.counter?p.counter:null"
                      />

                      <v-select
                        v-else-if="p.type == 'Column'"
                        :key="p_index"
                        v-model.lazy="p.value"
                        :disabled="p.isDisabledBy ? t[p.isDisabledBy].value:false"
                        :multiple="p.multiple"
                        :clearable="p.clearable"
                        :rules="VIZ_CONFIGS[element_temp.type][name][p_name].rules || []"
                        :items="_.map(data.columns,'name')"
                        :label="p_name"
                      />

                      <v-select
                        v-else-if="p.type == 'Select'"
                        :key="p_index"
                        v-model.lazy="p.value"
                        :disabled="p.isDisabledBy ? t[p.isDisabledBy].value:false"
                        :items="_.filter(p.items,o=>{return (p.max?o<=data[p.max].length:true) && (p.min?o>=data[p.min].length:true) })"
                        :label="p_name"
                        :rules="VIZ_CONFIGS[element_temp.type][name][p_name].rules || []"
                        :item-value="'value'"
                        :item-text="'value'"
                      />
                      <v-btn
                        v-else-if="p.type =='Button'"
                        :key="p_index"
                        small
                        text
                        depressed
                        color="success"
                        @click="VIZ_CONFIGS[element_temp.type][name][p_name]['atClick'](element_temp.options)"
                      >
                        <v-icon>{{ p.icon }}</v-icon> &nbsp;&nbsp;
                        {{ p_name }}
                      </v-btn>

                      <div
                        v-else-if="p.type == 'TableColumns'"
                        :key="p_index"
                        style="overflow:auto;white-space:nowrap;padding:10px;"
                      >
                        <div
                          v-for="(col, col_name,col_index) in element_temp.options.Columns['Column Parameters'].columns"
                          :key="col_index"
                          style="width:220px;display:inline-block;"
                          class="pr-2 mb-2"
                        >
                          <v-card class="pa-3">
                            <v-text-field
                              v-model.lazy="col.label"
                              name="label"
                              label="Column Label"
                              required
                            />
                            <v-select
                              v-model.lazy="col.align"
                              :items="['left','center','right']"
                              label="Align"
                            />
                            <!-- <v-text-field @change="handlePositionChange(col)" type='number'
                                                            :min="1"
                                                            :max="Object.keys(element_temp.options.Columns['Column Parameters'].columns).length"
                                                            name="position" label="Column Position"
                                                            v-model.lazy="col.position"></v-text-field> -->
                            <v-checkbox
                              v-model.lazy="col.visible"
                              :disabled="_.filter(element_temp.options.Columns['Column Parameters'].columns,{visible:true}).length<=1 && col.visible"
                              label="Show column ?"
                            />
                            <!-- <v-checkbox label="Use in searching ?" v-model.lazy="col.search"> </v-checkbox> -->
                          </v-card>
                        </div>
                        <!-- Display As Type -->
                        <!-- Format Type (Optional) -->
                      </div>

                      <v-checkbox
                        v-else-if="p.type=='Checkbox'"
                        :key="p_index"
                        v-model.lazy="p.value"
                        :disabled="p.isDisabledBy ? t[p.isDisabledBy].value:false"
                        :label="p_name"
                      />
                    </template>
                  </v-tab-item>
                </v-tabs>
              </v-form>
            </v-col>
            <v-col
              class="pl-5 pr-5"
              cols="5"
            >
              <div class="title mb-4">
                Preview
              </div>
              <dashboard-element
                v-if="element_temp.type != ''"
                style="height:250px;"
                :editable="false"
                :element="element_prop"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider />
      <v-card-actions class="text-right">
        <v-row>
          <v-col
            class="text-right pa-2"
            cols="12"
          >
            <v-btn
              text
              @click="dialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              @click="submit"
            >
              {{ (element.id || element.isPlaceholder) ?'Apply edition' : 'Create element' }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {
    VIZ_CONFIGS,
  } from './constants/VisualizationConfigs'
  import DashboardElement from './Element'
  import HELPER from './../../Dashboard/Views/Projects/Dashboards/helpers/helper'
  import VisualizationService from './../../Dashboard/Views/Projects/Dashboards/services/VisualizationService'
  export default {
    name: 'ElementBuilder',
    components: {
      'dashboard-element': DashboardElement,
    },
    mixins: [HELPER],
    props: {
      btnClass: {
        required: false,
        type: String,
        default: () => { return '' },

      },
      element: {
        required: false,
        type: Object,
        default: () => {
          return {
            name: 'Visualization name',
            type: '',
            options: {},
            data: {},
          }
        },
      },
      data: {
        required: false,
        type: Object,
        default: () => {
          return {
            columns: [],
            rows: [],
          }
        },
      },
    },
    data: () => ({
      VIZ_CONFIGS: VIZ_CONFIGS,
      height: window.innerHeight,
      dialog: false,
      rules: {
        type: [v => !!v || 'You need to specify a type'],
        label: [v => !!v || 'Enter a valid label', v => v.length <= 50 || 'Max characters is 50'],
      },
      element_temp: {
        valid: true,
        label: 'Visualization label',
        type: '',
        options: {},
      },
      configTab: 0,
      items: {
        types: [],
      },
    }),
    computed: {
      element_prop () {
        let e = this.element_temp
        e.data = this.data
        return e
      },
    },
    watch: {
      'element_temp.type' (n, o) {
        let self = this
        if ((_.isUndefined(this.element.id) || _.isNull(this.element.id)) && n == 'table') {
          this.$nextTick(() => {
            if (_.isEmpty(self.element_temp.options['Columns']['Column Parameters']['columns'])) { self.element_temp.options['Columns']['Column Parameters']['columns'] = self.getHeader(self.data.columns) }
          })
        }
      },
      dialog (n, o) {
        if (!n) {
          this.clear()
        }
      },
      element (n, o) {
        console.log('NEW ELEMENt', n)
        if (n.id) {
          // delete n.data
          this.element_temp = _.cloneDeep(n)
        }
      },
    },
    mounted () {
      if (this.element.id) {
        // delete this.element.data
        this.element_temp = _.cloneDeep(this.element)
        this.configTab = 0
      }

      this.items.types = Object.keys(VIZ_CONFIGS)

      let t = this
      window.onresize = () => {
        t.height = window.innerHeight
      }
    },
    methods: {
      handleTypeSelection () {
        if (this.element.id && this.element.type == this.element_temp.type) { this.element_temp.options = this.element.options } else { this.element_temp.options = _.cloneDeep(VIZ_CONFIGS[this.element_temp.type]) }
      },
      submit () {
        if (this.$refs.form.validate()) {
          let el = {
            id: this.element_temp.id,
            label: this.element_temp.label,
            type: this.element_temp.type,
            options: _.cloneDeep(this.element_temp.options),
          }
          if (el.id) { this.$emit('edit', el) } else { this.$emit('create', el) }
          this.clear()
          this.close()
        }
      },
      clear () {
        this.element_temp = {
          valid: true,
          label: 'Visualization label',
          type: '',
          options: {},
        }
        this.configTab = 0
        this.$refs.form.resetValidation()
      },
      close () {
        this.dialog = false
      },
    },
  }
</script>
<style scoped>

</style>
